module.exports = __webpack_public_path__ + "static/media/car.c4255a86.png";